<template lang="pug">
.boolean-field.form-field-radio
  .form-field-radio-label.form-field-label(v-if="label")
    span {{ label }}
    q-icon.cancel-select-field(name="cancel", v-if="checkIfCanCancel", @click.stop="resetValue()")

  .radio-row.form-radio
    q-radio(:value="value", :val="true", :label="issueCenterLocales.yes", @input="changeValue")
    q-radio(:value="value", :val="false", :label="issueCenterLocales.no", @input="changeValue")
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { issueCenterLocales } from "@/services/useLocales";

const props = defineProps({
  /* Лейбл чекбокса, строка */
  label: { type: String || null, default: null, required: false },
  /* Начальное значение поля, булеан или пустое значение, которое отображается на форме как незаполненное поле типа false */
  initialValue: { type: Boolean || null, default: null, required: false },
});

const emit = defineEmits(["change"]);

const value = ref(props.initialValue);

const checkIfCanCancel = computed(() => value.value === true || value.value === false);

const changeValue = val => {
  value.value = val;
  emit("change", val);
};

const resetValue = () => {
  changeValue(null);
};

onMounted(() => {
  emit("change", { value: props.initialValue });
});
</script>
